import React from "react";
import { usePagination } from "react-instantsearch";
import { isModifierClick } from "../utils/IsModifierClick";
import {
  UseCustomPaginationProps,
  PaginationItemProps,
} from "./types/CustomPaginationProps";

function CustomPagination(props: UseCustomPaginationProps) {
  const {
    pages,
    currentRefinement,
    nbPages,
    isFirstPage,
    isLastPage,
    refine,
    createURL,
  } = usePagination(props);
  const { onPageChange } = props;
  const firstPageIndex = 0;
  const previousPageIndex = currentRefinement - 1;
  const nextPageIndex = currentRefinement + 1;
  const lastPageIndex = nbPages - 1;

  const onClick = (page: number) => {
    refine(page);
    onPageChange(page);
  };

  return (
    <ul
      className={`pagination pagination--algolia ${
        nbPages < 2 ? "pagination--algolia-hide" : ""
      }`}
    >
      <PaginationItem
        isDisabled={isFirstPage}
        href={createURL(firstPageIndex)}
        onClick={() => onClick(firstPageIndex)}
      >
        <i className={"ph-fill ph-caret-double-left"} />
      </PaginationItem>
      <PaginationItem
        isDisabled={isFirstPage}
        href={createURL(previousPageIndex)}
        onClick={() => onClick(previousPageIndex)}
      >
        <i className={"ph-fill ph-caret-left"} />
      </PaginationItem>
      {pages.map((page) => {
        const label = page + 1;

        return (
          <PaginationItem
            key={page}
            isDisabled={false}
            aria-label={`Page ${label}`}
            href={createURL(page)}
            onClick={() => onClick(page)}
            className={currentRefinement === page ? "current" : ""}
          >
            {label}
          </PaginationItem>
        );
      })}
      <PaginationItem
        isDisabled={isLastPage}
        href={createURL(nextPageIndex)}
        onClick={() => onClick(nextPageIndex)}
      >
        <i className={"ph-fill ph-caret-right"} />
      </PaginationItem>
      <PaginationItem
        isDisabled={isLastPage}
        href={createURL(lastPageIndex)}
        onClick={() => onClick(lastPageIndex)}
      >
        <i className={"ph-fill ph-caret-double-right"} />
      </PaginationItem>
    </ul>
  );
}

function PaginationItem({
  isDisabled,
  href,
  onClick,
  ...props
}: PaginationItemProps) {
  if (isDisabled) {
    return (
      <li className="pagination-item pagination-item--algolia-disabled">
        <span {...props} />
      </li>
    );
  }

  return (
    <li className="pagination-item">
      <a
        href={href}
        onClick={(event) => {
          if (isModifierClick(event)) {
            return;
          }

          event.preventDefault();

          onClick(event);
        }}
        {...props}
      />
    </li>
  );
}

export default CustomPagination;
